import React from 'react'

const FeatursCard = ({ property }: { property: any }) => {

  console.log(property);
  return (
    <div key={property.id} className="bg-white border border-[#f1f1f1] shadow-md rounded-xl sm:rounded-2xl p-3 sm:p-4 md:p-6 hover:shadow-lg transition-shadow duration-300">
      <div className="flex flex-col lg:flex-row gap-4 sm:gap-6">
        {/* Image */}
        <div className="w-full lg:w-[390px] h-48 sm:h-56 md:h-64 lg:h-auto shrink-0">
          <img
            src={property.image}
            alt="Property"
            className="w-full h-full object-cover rounded-lg sm:rounded-xl"
          />
        </div>

        {/* Main Content */}
        <div className="flex-1 space-y-3 sm:space-y-4">
          {/* Title & Countdown */}
          <div className="flex flex-col sm:flex-row sm:justify-between gap-3 sm:gap-4">
            <div className="flex-1">
              <h2 className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-[#1d1d4e] leading-tight">{property.title}</h2>
              <p className="text-xs sm:text-sm mt-1 break-words text-gray-600">📍 {property.address}</p>
            </div>
            <div className="text-left sm:text-right">
              <p className="text-[11px] sm:text-[13px] text-gray-400 flex items-center gap-1 sm:justify-end">
                <span className="inline-block w-1.5 h-1.5 sm:w-2 sm:h-2 bg-gray-400 rounded-full"></span>
                Left to invest
              </p>
              <p className="text-[#6b3df2] text-sm sm:text-base md:text-lg font-bold">{property.countdown}</p>
            </div>
          </div>

          {/* Progress */}
          <div>
            <div className="w-full h-1.5 sm:h-2 bg-gray-300 rounded-full overflow-hidden">
              <div
                className="h-full bg-green-500 transition-all duration-300"
                style={{ width: `${property.progress}%` }}
              ></div>
            </div>
            <div className="flex justify-between text-[10px] sm:text-xs md:text-sm mt-1.5 sm:mt-2 flex-wrap gap-1">
              <span className="text-gray-700">$ {property.raised.toLocaleString()} ({property.progress}%)</span>
              <span className="font-medium text-gray-600">$ {property.goal.toLocaleString()} Goal</span>
            </div>
          </div>

          {/* Metrics */}
          <div className="border-t border-gray-200 pt-3 sm:pt-4">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 sm:gap-4">
              <div className="text-center">
                <p className="text-gray-500 text-[10px] sm:text-xs mb-1">Annual Return</p>
                <p className="text-[#6b3df2] font-semibold text-xs sm:text-sm break-words">{property.annualReturn}</p>
              </div>
              <div className="text-center border-l border-gray-200 pl-3 sm:pl-4">
                <p className="text-gray-500 text-[10px] sm:text-xs mb-1">Maximum Term</p>
                <p className="text-[#6b3df2] font-semibold text-xs sm:text-sm break-words">{property.maxTerm}</p>
              </div>
              <div className="text-center border-l border-gray-200 pl-3 sm:pl-4">
                <p className="text-gray-500 text-[10px] sm:text-xs mb-1">Property Type</p>
                <p className="text-[#6b3df2] font-semibold text-xs sm:text-sm break-words">{property.propertyType}</p>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          {/* <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pt-4">
        
            <div className="bg-[#d0f2fb] px-4 py-2 rounded-md flex items-center gap-3 text-sm text-[#1d1d4e] w-full sm:w-auto">
              <svg className="w-5 h-5 text-[#6b3df2]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 00-4 0L5 6v2a4 4 0 004 4v6m4 0v-6a4 4 0 004-4V6l-3-1.646a4 4 0 00-4 0z" />
              </svg>
              <div>
                  <p className="text-sm font-semibold">Security</p>
                <p className="text-[#265a42] font-bold">{property.security}</p>
              </div>
            </div>

            Buttons
            <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
              <button className="bg-[#6b3df2] text-white px-6 py-2 rounded-lg font-semibold shadow hover:bg-[#5a2ddb] transition w-full sm:w-auto">
                Invest Now
              </button>
              <button className="bg-white border border-gray-300 text-[#1d1d4e] px-6 py-2 rounded-lg font-semibold hover:bg-gray-100 transition w-full sm:w-auto">
                Details
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default FeatursCard